module.exports = __webpack_public_path__ + "static/media/Jumbotron.ba14f01f.svg";